import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(_Circle, { cx: "9", cy: "9", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Image";
const Image = memo(themed(Icon));
export {
  Image
};
//# sourceMappingURL=image.js.map
